import { render, staticRenderFns } from "./List.vue?vue&type=template&id=5245fdf4&scoped=true"
import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=5245fdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245fdf4",
  null
  
)

export default component.exports